<div class="custom-bottom-x-axis-labels" [ngStyle]="{'width.rem': chartWidthRems}">
  <div *ngFor="let label of labels" class="custom-bottom-x-axis-label">
    {{label}}
  </div>
</div>
